import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';
import { roundToNearest } from '@shared/utils';
import { secondsToReadable } from '@shared/utils/date-time';

@Pipe({
    name: 'appPunctuality',
    pure: true
})
export class PunctualityPipe implements PipeTransform {
    transform(value: number): any {
        if (!value) {
            return value;
        }

        const seconds = roundToNearest(value, 60);

        const formatted = secondsToReadable(Math.abs(seconds));

        if (value < 0) {
            return `${formatted} early`;
        }

        return `${formatted} late`;
    }
}
